import { memo } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

// Constants
import { ITabsProps } from "constants/navigation/transactionsMenu";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

const TransactionBlockTab: React.FC<ITabsProps> = ({ tabs, onClick }) => {
  const t = useTranslate();
  const location = useLocation();

  return (
    <div className="TransactionBlockTab">
      {tabs &&
        tabs.map((tab) => (
          <div
            className="TransactionBlockTab_button"
            key={tab.id}
            onClick={() => onClick(tab.url)}
          >
            <div
              className={classNames({
                // eslint-disable-next-line camelcase
                TransactionBlockTab_button_active: location.pathname.includes(
                  tab.url,
                ),
              })}
            >
              {t(tab.name)}
            </div>
          </div>
        ))}
    </div>
  );
};

export default memo(TransactionBlockTab);
